import { css } from '@emotion/react';
import {
  type FC, type ReactNode,
} from 'react';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';

type BoundarySettingsTableProps = Readonly<{
  dataHeadingLabel: string;
  dataRows: ReactNode;
  hideOpacity?: boolean;
  className?: string;
}>;

const tableStyle = css({
  width: '100%',
  borderSpacing: 0,
  borderCollapse: 'collapse',
});

const tableHeadingStyle = (theme: Theme) => css({
  color: theme.textColors.secondary,
  textTransform: 'uppercase',
  fontSize: '14px',
  paddingBlock: 16,
  paddingInline: 8,
  textAlign: 'left',
  '&:first-of-type': {
    paddingLeft: 24,
    paddingRight: 8,
  },
  '&:last-of-type': {
    paddingRight: 24,
  },
});

const tablePrimaryColumnStyle = css({
  width: '50%',
});

export const BoundarySettingsTableComponent: FC<BoundarySettingsTableProps> = (props) => {
  const [t] = useTranslation();

  return (
    <table css={tableStyle} className={props.className}>
      <thead>
        <tr>
          <th css={tableHeadingStyle}>{t('Fill Color')}</th>
          {!props.hideOpacity && <th css={tableHeadingStyle}>{t('Fill Opacity')}</th>}
          <th css={[tableHeadingStyle, tablePrimaryColumnStyle]}>{props.dataHeadingLabel}</th>
        </tr>
      </thead>
      <tbody>
        {props.dataRows}
      </tbody>
    </table>
  );
};
